import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton/CustomButton";
import Prices from "../Prices/Prices";

const ShopCard = ({
  device,
  onLearnMore,
  tabText = "",
  labels,
  isFromListing = true,
}) => {
  const { brand, characteristics } = device;
  const [selectedCharacteristic, setSelectedCharacteristic] = useState(null);

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
   window.location.ref(device?.url);
  };

  const handleColorSelect = (selectedColor) => {
    setSelectedCharacteristic(
      characteristics.find((char) => char.color === selectedColor),
    );
  };

  useEffect(() => {
    if (characteristics) {
      setSelectedCharacteristic(characteristics[0]);
    }
  }, [characteristics]);

  return (
    <div className="card border-0 shop-card">
      {/* Conditional Top Tag */}
      {tabText && (
        <div className="card-header">
          <span
            className="card-header-label"
            dangerouslySetInnerHTML={{ __html: tabText }}
          />
        </div>
      )}
      <div className="card-body text-center">
        <div className="device-top-section">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle">
            {selectedCharacteristic?.imageUrl == null ||
            selectedCharacteristic?.imageUrl === "" ? (
              <img
                loading="lazy"
                src={window.location.origin + device?.imageUrl}
                className="first-shop-img"
                alt={selectedCharacteristic?.name}
              />
            ) : (
              <img
                loading="lazy"
                src={window.location.origin + selectedCharacteristic?.imageUrl}
                className="first-shop-img"
                alt={selectedCharacteristic?.name}
              />
            )}
          </div>
          <div className={"bullet-icons"}>
            {characteristics
              ?.filter((char) => char?.color != null)
              ?.map((char, index) => (
                <span
                  key={index}
                  className={`g ${char?.color.toLowerCase()}`}
                  onClick={() => handleColorSelect(char?.color)}
                  style={{
                    border:
                      char?.productId !== device?.productId
                        ? "1px solid #dcdcdc"
                        : "none",
                    cursor: "pointer",
                    backgroundColor: char.color.toLowerCase(),
                  }}
                ></span>
              ))}
          </div>
          <div className="device-brand-text">{brand}</div>
          <div className="device-name-text">
            <a  href={`${window.location.origin}${device?.productUrl}`}  aria-label={"Λεπτομέρειες προϊόντος"}>
              {selectedCharacteristic?.name
                ? selectedCharacteristic?.name
                : device.displayName}
            </a>
          </div>
        </div>
        {selectedCharacteristic?.stock <= 0 && isFromListing === true && (
          <div className="availability-error-msg">Προσωρινά μη διαθέσιμο</div>
        )}
        <div className="device-bottom-section">
          <div className="shop-card-price-div">
            {selectedCharacteristic?.bundlePrice === undefined &&
            selectedCharacteristic?.initialPrice === undefined &&
            selectedCharacteristic?.finalPrice === undefined ? (
              <Prices item={device} labels={labels} />
            ) : (
              <Prices item={selectedCharacteristic} labels={labels} />
            )}
          </div>
          <CustomButton className="device-btn" role={"button"}  onClick={() => window.location.href = `${window.location.origin}${device?.productUrl}`}>
            {isFromListing === true
              ? labels[
                  selectedCharacteristic?.preOrder ? "comingSoon" : "learnMore"
                ]
              : labels["learnMore"]}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
